/* G Decor — Product description Read more / Read less toggle
   - Clamps long product descriptions, adds subtle brass-underlined toggle
   - Only activates if the description is significantly taller than the clamp
   May 2026
*/
(function(){
  'use strict';

  var CLAMP_PX = 220;       // visible height when collapsed
  var MIN_OVERFLOW = 80;    // only add toggle if content is at least this much taller

  function init(){
    if (!document.body.classList.contains('template-product')) return;
    var descriptions = document.querySelectorAll('.product-description.rte, .product-description');
    descriptions.forEach(setupReadMore);
  }

  function setupReadMore(desc){
    if (!desc || desc.dataset.gdReadmoreInit === '1') return;
    if (!desc.classList.contains('product-description') && !desc.classList.contains('rte')) return;

    // If wrapped in a disclosure/accordion, skip — user already controls visibility
    var insideDisclosure = desc.closest('details') || desc.closest('details-disclosure');
    if (insideDisclosure) return;

    // Measure content height. Defer to next frame to ensure layout is ready.
    requestAnimationFrame(function(){
      var contentHeight = desc.scrollHeight;
      if (contentHeight <= CLAMP_PX + MIN_OVERFLOW) return;

      desc.dataset.gdReadmoreInit = '1';

      // Wrap inner content
      var wrap = document.createElement('div');
      wrap.className = 'gd-product-readmore';
      var content = document.createElement('div');
      content.className = 'gd-product-readmore__content';

      // Move all children into content
      while (desc.firstChild) {
        content.appendChild(desc.firstChild);
      }
      wrap.appendChild(content);

      // Toggle button
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'gd-product-readmore__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.innerHTML = '<span class="gd-product-readmore__toggle-label">Read more</span><span class="gd-product-readmore__toggle-chev" aria-hidden="true">+</span>';
      toggle.addEventListener('click', function(){
        var isExpanded = wrap.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        toggle.querySelector('.gd-product-readmore__toggle-label').textContent = isExpanded ? 'Read less' : 'Read more';
        toggle.querySelector('.gd-product-readmore__toggle-chev').textContent = isExpanded ? '–' : '+';
      });
      wrap.appendChild(toggle);

      desc.appendChild(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
